import service from '@/services/admin/mail'

const getDefaultState = () => ({
  session: null,
  mail: {
    img: null,
    emailOptions: {
      byeMessage: 'Gracias por su compra',
      info: 'ESTE DOCUMENTO se emite bajo las condiciones de la Resolución DGT-R-48-2016 del 7 de octubre del 2016.',
      signature: {
        sign: '',
        name: '',
        title: ''
      },
      mainColor: '#007aff',
      template: 1
    }
  },

  saved: null
})

export const state = () => getDefaultState()

export const mutations = {
  RESET_STATE: state => Object.assign(state, getDefaultState()),
  RESET: state => (state.mail = getDefaultState().mail),
  SET: (state, obj) => {
    if (!obj || !obj.emailOptions) {
      state.mail = getDefaultState().mail
    } else {
      state.mail = obj
      state.saved = true

      if (!obj.emailOptions.signature?.sign)
        state.mail.emailOptions.signature = {
          sign: '',
          name: '',
          title: ''
        }
      if (!obj.emailOptions.mainColor) state.mail.emailOptions.mainColor = '#007aff'
      if (!obj.emailOptions.template) state.mail.emailOptions.template = 1
    }
  },
  DELETE_IMG: state => {
    state.mail.img = null
  },
  SAVE_CHANGES: (state, obj) => {
    state.mail = obj
    state.saved = false
  }
}

export const actions = {
  create: async ({ commit, rootGetters }, item) =>
    service
      .create({
        ...item,
        emisor: {
          _id: await rootGetters['facturacion/emisorStore/get_Id']
        }
      })
      .then(response => {
        commit('SET', item)
        return true
      }),

  deleteImg: async ({ commit, rootGetters, state }) =>
    service.deleteImg(await rootGetters['facturacion/emisorStore/get_Id'], `${await rootGetters['facturacion/emisorStore/get_Id']}/logo.png`).then(response => {
      commit('DELETE_IMG')
      return true
    }),

  readEmailData: async ({ commit, rootGetters }) => {
    return service.readEmailData(await rootGetters['facturacion/emisorStore/get_Id']).then(response => {
      commit('SET', response)
      return response
    })
  }
}

export const getters = {
  getUserId: state => state.mail.id
}
